import { DatePipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-end-location-main',
  standalone: true,
  imports: [
    TranslateModule,
    DatePipe
  ],
  templateUrl: './end-location-main.component.html',
  styleUrls: ['./end-location-main.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EndLocationMainComponent {
  public title: InputSignal<string> = input<string>(); // TODO: CAMBIAR A OBJETO DE TRADUCCIONES
  public startDate: InputSignal<Date> = input<Date>();
}
